import { render, staticRenderFns } from "./LoginPageParent.vue?vue&type=template&id=16fef7c2&scoped=true"
import script from "./LoginPageParent.vue?vue&type=script&lang=js"
export * from "./LoginPageParent.vue?vue&type=script&lang=js"
import style0 from "./LoginPageParent.vue?vue&type=style&index=0&id=16fef7c2&prod&scoped=true&lang=css"
import style1 from "./LoginPageParent.vue?vue&type=style&index=1&id=16fef7c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fef7c2",
  null
  
)

export default component.exports